<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-09-20 13:57:15
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-12 22:35:58
 * @FilePath: /chaoyongtuan/src/modules/async/goods/synchronizationList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="synchronization-list">
		<div class="synchronization-head">
			<div class="commander-info font-h4-medium">团长信息</div>
			<div class="commander-ID font-h4-medium">团长ID</div>
			<div class="snchronous-not font-h4-medium">是否可同步</div>
		</div>
		<div class="commander-content" v-loading="loading" v-if="list.length">
			<div class="commander-list" v-for="item in list" :key="item.authority_id" @click="selectClick(item)">
				<div class="commander-name">
					<el-radio :value="+authorityId" :label="+item.authority_id" :disabled="item.sync_time > 0"></el-radio>
					<div class="institution_name">{{ item.institution_name }}</div></div
				>
				<el-tooltip placement="top" :open-delay="300">
					<div slot="content">
						<span>团长ID</span>
						<span class="ml-4">{{ item.authority_id || '-' }}</span>
						<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy(item.authority_id)"></i>
					</div>
					<div class="commander-only">{{ (item.authority_id + '') | textFormat(17) }}</div>
				</el-tooltip>
				<div class="commander-snchronous">
					<down-time v-if="item.sync_time" @done="timeEnd" :deadline="item.sync_time" :ignoreDay="false">
						<template v-slot="props">
							<span class="down-time">{{ props.hour }}:{{ props.minute }}:{{ props.second }}s</span>
							<span class="down-text">后可同步</span>
						</template>
					</down-time>
					<div class="font-h6-regular" v-else>可同步</div>
				</div>
			</div>
		</div>
		<empty v-else ref="empty" slot="empty"></empty>
	</div>
</template>
<script>
import { getCommanderList } from '@/components/commanderSelect/index.js';
import empty from '@/views/common/empty/index.vue';
import DownTime from '@/components/common/DownTime';
import { copy } from '@/utils/common';
export default {
	data() {
		return {
			list: [],
			authorityId: -1,
			loading: false,
		};
	},
	props: {
		platformId: {
			type: [Number, String],
			default: 1,
		},
	},
	components: {
		DownTime,
		empty,
	},
	methods: {
		async getList() {
			try {
				this.loading = true;
				this.list = await getCommanderList(true, this.platformId, true);
			} finally {
				this.loading = false;
			}
		},
		selectClick(item) {
			if (item.sync_time) {
				return;
			}
			this.authorityId = item.authority_id;
			this.$emit('change', item);
		},
		timeEnd() {
			this.getList();
		},
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
	},
	created() {
		this.getList();
	},
};
</script>
<style lang="less" scoped>
.synchronization-list {
	.synchronization-head {
		display: flex;
		align-items: center;
		padding: 16px;
		border-bottom: 1px solid @border-color-base;
		.commander-info {
			width: 206px;
			color: @color-text-regular;
		}
		.commander-ID {
			width: 206px;
			color: @color-text-regular;
		}
		.snchronous-not {
			width: 140px;
			color: @color-text-regular;
		}
	}
	.commander-content {
		max-height: 280px;
		overflow: auto;
		/deep/ .el-radio__label {
			padding-left: 0px;
			display: none;
		}
	}
	.commander-list {
		cursor: pointer;
		display: flex;
		align-items: center;
		padding: 16px;
		border-bottom: 1px solid @border-color-base;
		/deep/ .el-radio {
			position: relative;
			top: 3px;
			margin-right: 12px;
		}
		.commander-name {
			display: flex;
			width: 206px;
			color: @color-text-regular;
			.institution_name {
				width: 96px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}
		}
		.commander-only {
			width: 206px;
			color: @color-text-regular;
		}
		.commander-snchronous {
			width: 140px;
			color: @color-text-regular;
		}
	}
	.down-time {
		display: inline-block;
		min-width: 60px;
		color: @color-o;
		font-size: 12px;
		font-family: 'PingFangSC-Regular';
	}
	.down-text {
		color: @color-o;
		font-family: 'PingFangSC-Regular';
	}
}
</style>
